import { useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getWeightCertificates } from '../../use-cases/getWeightCertificates'

export function useGetWeightCertificates(shipmentUUID: string, enabled: boolean) {
  const { call, result, status, error } = useAsync(getWeightCertificates)
  const abortController = useAbortController()

  useEffect(() => {
    if (enabled) {
      call({
        shipmentUUID,
        config: {
          signal: abortController.signal,
        },
      })
    }
  }, [abortController, call, enabled, shipmentUUID])

  function fetchWeightCertificates(shipmentUUID: string) {
    return call({
      shipmentUUID,
      config: {
        signal: abortController.signal,
      },
    })
  }

  return {
    weightCertificates: result,
    status,
    error,
    fetchWeightCertificates,
  }
}
